// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layoutContainer {\n  position: relative;\n  min-height: 100vh;\n}\n\n.spb-layout-container {\n  display: flex;\n  flex-flow: column;\n  flex: 1 1 auto;\n  width: 100%;\n  padding: 0;\n  min-height: unset !important;\n  align-content: space-between;\n  background: #f1f1f1 0 0 no-repeat padding-box;\n}\n\n.flex-1-1 {\n  width: 100%;\n  flex: 1 1 auto;\n}", ""]);
// Exports
module.exports = exports;
